export default __webpack_public_path__ + "static/media/diamond.915f5aa5.svg";